var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrugAdmChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.952856 13.1744C-0.317619 11.9151 -0.317619 9.87337 0.952856 8.61408L8.69056 0.94447C9.96103 -0.314823 12.0209 -0.314824 13.2914 0.94447C14.5618 2.20376 14.5618 4.24548 13.2914 5.50478L5.55365 13.1744C4.28318 14.4337 2.22333 14.4337 0.952856 13.1744Z",
    fill: "#FF6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5309 15.2272C15.5309 16.8057 12.8341 18 9.68981 18C6.54554 18 3.90203 16.7324 3.90203 15.1539V14.0365L9.80989 16.2412L15.697 13.8347L15.5309 15.2272Z",
    fill: "#F6AD3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6501C16 14.6334 13.3625 16.2412 9.80989 16.2412C6.25728 16.2412 3.37732 14.6334 3.37732 12.6501C3.37732 10.6668 6.25728 9.05904 9.80989 9.05904C13.3625 9.05904 16 10.6668 16 12.6501Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5309 12.6501C15.5309 14.2286 12.9819 15.5083 9.83768 15.5083C6.69342 15.5083 4.14449 14.2286 4.14449 12.6501C4.14449 11.0715 6.69342 9.79188 9.83768 9.79188C12.9819 9.79187 15.5309 11.0715 15.5309 12.6501Z",
    fill: "#F6AD3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32608 4.27934L7.62593 6.56004L9.92578 8.84074L9.51485 9.24804L4.93097 4.67097L5.32608 4.27934Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7739 9.9505L10.1162 12.7964L8.45847 15.6424L7.94622 15.3492L11.2616 9.65735L11.7739 9.9505Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34651 9.7704C1.38327 9.70729 1.51177 9.71425 1.57543 9.75068C1.62506 9.77908 1.65078 9.83576 1.63929 9.89141L1.49023 10.6134C1.40973 11.0033 1.48249 11.4052 1.68708 11.7397C1.78542 11.9005 1.93265 12.0239 2.08448 12.1366L2.39992 12.3708C2.4884 12.4365 2.60395 12.5283 2.54867 12.6232C2.51191 12.6863 2.37484 12.7992 2.31117 12.7628L2.18908 12.6929C1.05423 12.1032 0.684546 11.0772 1.27602 9.89141L1.34651 9.7704Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3459 13.0277C14.3459 13.1005 14.2311 13.1582 14.1576 13.1582C14.0474 13.1582 14.0313 13.0123 14.0313 12.9032V12.7431C14.0313 12.4837 14.0094 12.2167 13.8744 11.9944C13.6986 11.705 13.4359 11.4948 13.1576 11.3578C12.9919 11.2762 12.8082 11.2413 12.6246 11.2185L12.5425 11.2084C12.3874 11.1891 12.1727 11.2372 12.1019 11.099C12.0928 11.0811 12.0873 11.0593 12.0873 11.0329C12.0873 10.96 12.1402 10.8863 12.2352 10.8863C13.4346 11.0278 14.4739 11.4948 14.3625 12.7489C14.3543 12.8416 14.3459 12.9346 14.3459 13.0277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrugAdmChart);
export default __webpack_public_path__ + "static/media/DrugAdmChart.efa767d81325d59368ddcb3e44d82e01.svg";
export { ForwardRef as ReactComponent };